import {
  SelectInput,
  SelectInputProps,
} from "@/lib/Components/Form/Inputs/SelectInput";
import { HireUnitType } from "@/gql/graphql";

const HIRE_UNIT_LABELS: Record<HireUnitType, string> = {
  [HireUnitType.Day]: "Days",
  [HireUnitType.Night]: "Nights",
  [HireUnitType.TwentyFourHours]: "24hrs",
};

export function hireUnitLabel(value?: HireUnitType | null): string | undefined {
  return value ? HIRE_UNIT_LABELS[value] : undefined;
}

export function HireUnitTypeInput(
  props: Omit<SelectInputProps<any>, "options">,
) {
  const options: {
    [key in HireUnitType]: {
      label: string;
      value: HireUnitType;
    };
  } = {
    [HireUnitType.Day]: {
      label: HIRE_UNIT_LABELS[HireUnitType.Day],
      value: HireUnitType.Day,
    },
    [HireUnitType.Night]: {
      label: HIRE_UNIT_LABELS[HireUnitType.Night],
      value: HireUnitType.Night,
    },
    [HireUnitType.TwentyFourHours]: {
      label: HIRE_UNIT_LABELS[HireUnitType.TwentyFourHours],
      value: HireUnitType.TwentyFourHours,
    },
  };

  return (
    <SelectInput
      options={[
        {
          label: "unit",
          options: Object.values(options),
        },
      ]}
      {...props}
    />
  );
}
